import { ProcessorType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/values/values.pb';
import { InvoiceModel, PaymentModel, PaymentType } from '@frontend/api-invoices';
import { maskAccountNumber } from '@frontend/string';

export const isCareCreditPayment = (payment?: PaymentModel) =>
  payment?.processorType === ProcessorType.CARE_CREDIT_PROCESSOR || payment?.paymentType === PaymentType.CareCredit;

export const getInvoicePayments = (invoice: InvoiceModel) =>
  [invoice.payment, ...(invoice.payments ?? [])].filter((payment): payment is PaymentModel => !!payment);

export const getCareCreditLastFour = (accountNumber?: string) =>
  maskAccountNumber(accountNumber, { showLast: 4, maxMaskLength: 0, normalizeDigits: true });

export const getAccountLookupKey = (merchantNumber: string, phoneNumber: string) => `${merchantNumber}:${phoneNumber}`;
